export const getBaseWithoutKey = (path: string[], idOrPath: string) => {
  const base = path.slice(0, path.indexOf(idOrPath));
  const rest = path.slice(path.indexOf(idOrPath));
  const baseWithoutKey = base.filter(
    path => !['identify', 'not-found', 'access', 'error', 'maintenance'].includes(path)
  );

  return { baseWithoutKey, rest, base };
};
